import { diDecorator } from "@/backend/di/diDecorator";
import { ExtractEntity } from "@/backend/shared/repository/BaseEntity";

import { BaseUpdatableService } from "../../../shared/application/base.service";
import { ISubscription } from "../domain/Subscription";
import { ISubscriptionHistory, ISubscriptionHistoryCreating } from "../domain/SubscriptionHistory";
import { type SubscriptionHistoryRepository } from "../domain/subscriptionHistory.repository";

//

@diDecorator.injectable()
export class SubscriptionHistoryService extends BaseUpdatableService<
  ISubscriptionHistory,
  ISubscriptionHistoryCreating
> {
  constructor(
    @diDecorator.inject("SubscriptionHistoryRepository")
    public repository: SubscriptionHistoryRepository,
  ) {
    super(repository);
  }

  //

  public async addCreated(data: ExtractEntity<ISubscription>, session?: unknown) {
    const { organizationId } = data;
    return await this.repository.create({ action: "CREATED", organizationId, data }, session);
  }

  //

  public async addPlanUpdated(data: ExtractEntity<ISubscription>, session?: unknown) {
    const { organizationId } = data;
    return await this.repository.create({ action: "PLAN_UPDATED", organizationId, data }, session);
  }

  //

  public async addStatusUpdated(data: ExtractEntity<ISubscription>, session?: unknown) {
    const { organizationId } = data;
    return await this.repository.create(
      { action: "STATUS_UPDATED", organizationId, data },
      session,
    );
  }
}
